<div class="sidebar-main">
    <ng-container *ngIf="!isMobile">
        <div class="sidebar-main-top" (click)="goToDashboard()">
            <img class="brand-logo" src="assets/svg/icons/brand-logo.svg" alt="Klinq logo" />
        </div>
        <nav class="nav-menu">
            <ng-container *ngTemplateOutlet="homeNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="historyNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="helpNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="moreNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="rewardWalletNavMenuTemplate"></ng-container>
        </nav>
        <div class="sidebar-main-bottom">
            <div class="profile" (click)="profileOpen()">
                <img
                    class="profile-avatar"
                    [src]="customerProfile ? customerProfile : 'assets/svg/icons/user-placeholder.svg'"
                    alt="Profile"
                />
                <div class="profile-details">
                    <p class="profile-details-name">
                        {{
                            customerDetails?.nickName && customerDetails?.nickName !== ""
                                ? customerDetails?.nickName
                                : "---"
                        }}
                    </p>
                    <p class="profile-details-id">Customer ID: {{ customerDetails?.customerId ?? "---" }}</p>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isMobile">
        <nav class="bottom-nav-menu">
            <ng-container *ngTemplateOutlet="homeNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="historyNavMenuTemplate"></ng-container>
            <span class="nav-menu-item"></span>
            <ng-container *ngTemplateOutlet="rewardWalletNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="helpNavMenuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="moreNavMenuTemplate"></ng-container>
        </nav>
    </ng-container>
</div>

<ng-template #homeNavMenuTemplate>
    <button
        type="button"
        class="nav-menu-item"
        [ngClass]="{
            active: selectedTab === menuItems.HOME.key,
            inactive: selectedTab !== menuItems.HOME.key,
        }"
        (click)="navigateTo(menuItems.HOME.route, menuItems.HOME.key)"
    >
        <span class="nav-menu-item-icon">
            <img
                [src]="selectedTab === menuItems.HOME.key ? menuItems.HOME.activeIcon : menuItems.HOME.icon"
                [alt]="menuItems.HOME.label"
            />
        </span>
        <span class="nav-menu-item-label">{{ menuItems.HOME.label }}</span>
    </button>
</ng-template>
<ng-template #historyNavMenuTemplate>
    <button
        type="button"
        class="nav-menu-item"
        [ngClass]="{
            active: selectedTab === menuItems.HISTORY.key,
            inactive: selectedTab !== menuItems.HISTORY.key,
        }"
        (click)="navigateTo(menuItems.HISTORY.route, menuItems.HISTORY.key)"
    >
        <span class="nav-menu-item-icon">
            <img
                [src]="selectedTab === menuItems.HISTORY.key ? menuItems.HISTORY.activeIcon : menuItems.HISTORY.icon"
                [alt]="menuItems.HISTORY.label"
            />
        </span>
        <span class="nav-menu-item-label">{{ menuItems.HISTORY.label }}</span>
    </button>
</ng-template>
<ng-template #helpNavMenuTemplate>
    <button
        type="button"
        class="nav-menu-item"
        [ngClass]="{
            active: selectedTab === menuItems.HELP.key,
            inactive: selectedTab !== menuItems.HELP.key,
        }"
        (click)="navigateTo(menuItems.HELP.route, menuItems.HELP.key)"
    >
        <span class="nav-menu-item-icon">
            <img
                [src]="selectedTab === menuItems.HELP.key ? menuItems.HELP.activeIcon : menuItems.HELP.icon"
                [alt]="menuItems.HELP.label"
            />
        </span>
        <span class="nav-menu-item-label">{{ menuItems.HELP.label }}</span>
    </button>
</ng-template>
<ng-template #moreNavMenuTemplate>
    <button
        type="button"
        class="nav-menu-item"
        [ngClass]="{
            active: selectedTab === menuItems.MORE.key,
            inactive: selectedTab !== menuItems.MORE.key,
        }"
        (click)="navigateTo(menuItems.MORE.route, menuItems.MORE.key)"
    >
        <span class="nav-menu-item-icon">
            <img
                [src]="selectedTab === menuItems.MORE.key ? menuItems.MORE.activeIcon : menuItems.MORE.icon"
                [alt]="menuItems.MORE.label"
            />
        </span>
        <span class="nav-menu-item-label">{{ menuItems.MORE.label }}</span>
    </button>
</ng-template>
<ng-template #rewardWalletNavMenuTemplate>
    <button
        type="button"
        class="nav-menu-item reward-circle-btn"
        [ngClass]="{
            active: selectedTab === menuItems.REWARD_WALLET.key,
            inactive: selectedTab !== menuItems.REWARD_WALLET.key,
        }"
        (click)="navigateTo(menuItems.REWARD_WALLET.route, menuItems.REWARD_WALLET.key)"
    >
        <span class="nav-menu-item-icon">
            <img
                [src]="
                    selectedTab === menuItems.REWARD_WALLET.key
                        ? menuItems.REWARD_WALLET.activeIcon
                        : menuItems.REWARD_WALLET.icon
                "
                [alt]="menuItems.REWARD_WALLET.label"
            />
        </span>
        <span class="nav-menu-item-label">{{ menuItems.REWARD_WALLET.label }}</span>
    </button>
</ng-template>
